import { FinancialYearOut } from '../../../../store/api';
import { reservesConfig } from '../../../../config';
import { http } from '../../../../api/axios';

export const fetchFinancialYears = async () => {
    return await http.get<FinancialYearOut[]>(reservesConfig().endpointReserveFinancialYears).then(res => res.data);
};
